import Amplitude from "@Shared/@Utils/amplitude";
const mutations = {
  SOCKET_ONOPEN(state) {
    state.isConnected = true;
    state.retry = 0;
  },
  SOCKET_ONCLOSE(state) {
    state.isConnected = false;
    state.retry += 1;
  },
  SOCKET_ONERROR(state, event) {
    console.error(state, event);
  },
  SOCKET_ONMESSAGE(state, message) {
    state.message = message;
    state.messages.unshift(message);
  },
  SOCKET_RECONNECT() {},
  SOCKET_RECONNECT_ERROR(state) {
    Amplitude.logHandledError({
      message: "Websocket reconnect failed after 5 attemps",
      name: "websocket_reconnect_error"
    }, {
      event_type: "websocket_reconnect_error",
      state
    });
    state.reconnectError = true;
  }
};
export default mutations;